import { Pipe, PipeTransform } from '@angular/core';
import { EVENT_CELL_COLUMN_DEF, SELECT_CELL_COLUMN_DEF } from './table.constants';
import { TableColumn } from './table.model';

@Pipe({
  name: 'toDisplayedColumns',
  standalone: true,
})
export class ToDisplayedColumnsPipe implements PipeTransform {
  transform(
    columns: TableColumn[],
    options: { isCellEventsPresent?: boolean; isSelectionModeOn?: boolean } = {}
  ): string[] {
    if (columns == null) {
      return [];
    }

    const { isCellEventsPresent = false, isSelectionModeOn = false } = options || {};

    let colDefinitions = columns.map(c => c.path ?? c.field);

    if (isCellEventsPresent) {
      colDefinitions = [EVENT_CELL_COLUMN_DEF, ...colDefinitions];
    }

    if (isSelectionModeOn) {
      colDefinitions = [SELECT_CELL_COLUMN_DEF, ...colDefinitions];
    }

    return colDefinitions;
  }
}
